"use client";

import React from "react";

import { formatCompact, useYoutubeStats } from "@/hooks/useYoutubeStats";
import { cn } from "@/lib/utils";

export default function SubCount({
  handle,
  channelId,
  style,
  language,
  className,
}: {
  handle?: string;
  channelId?: string;
  style?: React.CSSProperties;
  language: "en" | "de";
  className?: string;
}) {
  const { data, isLoading } = useYoutubeStats({ handle, channelId });
  const text = isLoading
    ? "141k"
    : data?.hiddenSubscriberCount
      ? "141k"
      : formatCompact(data?.subscriberCount);

  return (
    <p className={cn("leading-none mb-0 text-white/70", className)}>
      {text} {language === "en" ? "Subscribers" : "Abonnenten"}
    </p>
  );
}
